/* House of Khilonay - dispatch cutoff + delivery estimate.

   Honest by design: the countdown runs to a real daily dispatch cutoff
   in Karachi time and stops when it passes. It does not reset on reload.
   Delivery dates are the real 3-5 working day window, Sundays excluded.

   CHANGE THESE TWO IF YOUR DISPATCH TIMES CHANGE. */
(function () {
  var CUTOFF_HOUR = 17;   // 5 PM Karachi - last dispatch to PostEx
  var MIN_DAYS = 3;       // fastest delivery, working days
  var MAX_DAYS = 5;       // slowest delivery, working days

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var OFFSET = 5 * 3600 * 1000; // Pakistan is UTC+5 year round, no DST

  // Read Karachi wall-clock via UTC getters on a shifted timestamp.
  function karachi() {
    return new Date(Date.now() + OFFSET);
  }

  function cutoffTimestamp(k) {
    return Date.UTC(k.getUTCFullYear(), k.getUTCMonth(), k.getUTCDate(), CUTOFF_HOUR, 0, 0) - OFFSET;
  }

  function addDay(d) {
    return new Date(d.getTime() + 86400000);
  }

  // Sunday is our only closed day - shop hours are Mon to Sat.
  function nextWorkingDay(d) {
    var out = addDay(d);
    while (out.getUTCDay() === 0) out = addDay(out);
    return out;
  }

  function addWorkingDays(from, n) {
    var out = from;
    for (var i = 0; i < n; i++) out = nextWorkingDay(out);
    return out;
  }

  function formatDate(d) {
    return DAYS[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
  }

  function build() {
    var k = karachi();
    var msLeft = cutoffTimestamp(k) - Date.now();
    var isSunday = k.getUTCDay() === 0;
    var dispatchToday = !isSunday && msLeft > 0;

    var dispatch = dispatchToday ? k : nextWorkingDay(k);
    var from = addWorkingDays(dispatch, MIN_DAYS);
    var to = addWorkingDays(dispatch, MAX_DAYS);
    var window = formatDate(from) + ' and ' + formatDate(to);

    if (dispatchToday) {
      var hrs = Math.floor(msLeft / 3600000);
      var mins = Math.floor((msLeft % 3600000) / 60000);
      var left = hrs > 0 ? hrs + ' hr ' + mins + ' min' : mins + ' min';
      return {
        live: true,
        html: '<strong>Order in the next ' + left + '</strong> and we dispatch it today \u2014 ' +
              'expected between <strong>' + window + '</strong>'
      };
    }

    return {
      live: false,
      html: 'Order now and we dispatch it <strong>' + formatDate(dispatch) + '</strong> \u2014 ' +
            'expected between <strong>' + window + '</strong>'
    };
  }

  var node = null;
  var ticker = null;

  function render() {
    if (!node) return;
    var state = build();
    node.querySelector('.hok-cutoff__text').innerHTML = state.html;
    if (!state.live && ticker) {
      clearInterval(ticker);
      ticker = null;
    }
  }

  function mount() {
    if (document.querySelector('.hok-cutoff')) return;
    var anchor = document.querySelector('.hok-wa'); // product pages only
    if (!anchor) return;

    node = document.createElement('div');
    node.className = 'hok-cutoff';
    node.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' +
      '<p class="hok-cutoff__text"></p>';

    anchor.parentNode.insertBefore(node, anchor);
    render();
    ticker = setInterval(render, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
